import {
  FILL_INTENTS,
  IntentActionTypes,
  saveIntentActionType,
  deleteIntentActionType,
  buildIntentActionType,
} from '../../model/intent/action';
import { Intent } from '../../model/intent/types';
import { createActions } from '../../helpers/actionsHelper';

export const saveIntentAction = createActions<IntentActionTypes, Intent, Intent>(saveIntentActionType);

export const deleteIntentAction = createActions<IntentActionTypes, string, {}>(deleteIntentActionType);

export function fillIntents(intents: Intent[]): IntentActionTypes {
  return {
    type: FILL_INTENTS,
    payload: intents,
  };
}

export function buildIntent(intentId: string): IntentActionTypes {
  return {
    type: buildIntentActionType,
    payload: intentId,
  };
}
